module.exports = __webpack_public_path__ + "static/img/introductionTitle.c62f3cb7.png";